<template>
  <header>
    <div id="header-sticky" :class="`${isSticky
      ? 'header__area header__transparent header__padding-2 sticky'
      : 'header__area header__transparent header__padding-2'
      }`">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-xxl-4 col-xl-4 col-lg-6 col-md-6 col-sm-6 col-6">
            <div class="header__left d-flex">
              <div class="logo d-flex align-items-center">
                <router-link to="/">
                  <img class="logo-white" src="../../assets/img/logo/logo-2.png" alt="logo" />
                  <img class="logo-black" src="../../assets/img/logo/logo.png" alt="logo" />
                </router-link>
              </div>
              <div class="logo header__category d-lg-block">
                <nav>
                  <ul>
                    <li>
                      <router-link to="/">
                        <img class="logo-white" src="../../assets/img/logo/logo-2-ufdpar.png" alt="logo" />
                        <img class="logo-black" src="../../assets/img/logo/logo-ufdpar.png" alt="logo" />
                      </router-link>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>

          <div class="col-xxl-5 col-xl-5 d-none d-xl-block">
            <div class="main-menu main-menu-3">
              <nav id="mobile-menu">
                <ul>
                  <!-- <li><router-link to="/inicio">Inicio</router-link></li> -->
                  <li><router-link to="/">Início</router-link></li>
                  <li><router-link to="/questionario">Questionário</router-link></li>
                  <li><router-link to="/oportunidades">Oportunidades</router-link></li>
                  <li v-if="adm"><router-link to="/administrativo">Administrativo</router-link></li>
                </ul>
              </nav>
            </div>
          </div>
          <div class="col-xxl-3 col-xl-3 col-lg-6 col-md-6 col-sm-6 col-6">
            <div class="
                header__right
                d-flex
                justify-content-end
                align-items-center
              ">

              <div class="header__user ml-20 d-none d-sm-flex align-items-center">

                <div class="logo d-flex align-items-center">
                  <router-link to="/">
                    <span class="user-name mr-20" :class="isSticky ? 'text-black' : 'text-white'">{{ nome }}</span>
                  </router-link>
                </div>
                <button v-if="keycloak?.authenticated" @click="sair" class="btn btn-light rounded-pill mr-10 d-flex align-items-center">
                  <i class="fal fa-user mr-10"></i>
                  Sair
                </button>
                <button v-else @click="entrar" class="btn btn-light rounded-pill mr-10 d-flex align-items-center">
                  <i class="fal fa-user mr-10"></i>
                  Entrar
                </button>

              </div>
              <div class="sidebar__menu d-xl-none">
                <div @click="handleSidebar" class="sidebar-toggle-btn sidebar-toggle-btn-white ml-30"
                  id="sidebar-toggle">
                  <span class="line"></span>
                  <span class="line"></span>
                  <span class="line"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>


  <!-- sidebar area start -->
  <div :class="`${showSidebar ? 'sidebar__area sidebar-opened' : 'sidebar__area'}`">
    <div class="sidebar__wrapper">
      <div @click="handleSidebarClose" class="sidebar__close">
        <button class="sidebar__close-btn" id="sidebar__close-btn">
          <span><i class="fal fa-times"></i></span>
          <span>fechar</span>
        </button>
      </div>
      <div class="sidebar__content">
        <div class="logo mb-40">
          <router-link to="/">
            <img src="../../assets/img/logo/logo.png" alt="logo">
          </router-link>
        </div>


        <div class="side-info-content sidebar-menu mm-menu">

          <ul>
            <li>
              <router-link to="/inicio" class="border-0">Início</router-link>
            </li>
            <li>
              <router-link to="/questionario" class="border-0">Questionário</router-link>
            </li>
            <li>
              <router-link to="/oportunidades" class="border-0">Oportunidades</router-link>
            </li>
            <li v-if="adm">
              <router-link to="/administrativo" class="border-0">Administrativo</router-link>
            </li>
          </ul>
        </div>
        <hr>
        <div class="header__user d-sm-flex align-items-center" style="width:100%;">
          <div class="logo d-flex align-items-center justify-content-between" style="width:100%; flex-wrap: nowrap;">
            <router-link to="/">
              <span class="user-name text-black">Olá, {{ nome }}</span>
            </router-link>
            <button v-if="keycloak?.authenticated" @click="sair" class="btn btn-light rounded-pill d-flex align-items-center">
              <i class="fal fa-user mr-10"></i>
              Sair
            </button>
            <button v-else @click="entrar" class="btn btn-light rounded-pill mr-10 d-flex align-items-center">
              <i class="fal fa-user mr-10"></i>
              Entrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div @click="handleSidebarClose" :class="[showSidebar ? 'body-overlay opened' : 'body-overlay']"></div>

</template>

<script>
import keycloak from '@/keycloak';
export default {
  name: "HomeThreeHeader",
  data() {
    return {
      nome: '',
      adm: false,
      keycloak,
      isSticky: false,
      searchOption: false,
      showSidebar: false,
      menuOption: {
        menuShow: false,
        menuSearch: false,
        homeDropdown: false,
        coursesDropdown: false,
        pagesDropDown: false,
        blogDropdown: false,
        aboutDropdown: false,
      },
    };
  },
  methods: {
    handleSticky() {
      if (window.scrollY > 80) {
        this.isSticky = true;
      } else {
        this.isSticky = false;
      }
    },
    handleSidebar() {
      this.showSidebar = true;
    },
    handleSidebarClose() {
      this.showSidebar = false;
    },
    handleSearch() {
      this.searchOption = true;
    },
    handleSearchClose() {
      this.searchOption = false;
    },
    isAuthenticated() {
      if (this.keycloak?.authenticated) {
        this.nome = this.keycloak.tokenParsed?.given_name || "Entre";
        const roles = keycloak.tokenParsed?.resource_access?.["vue-app"]?.roles || [];
        if (roles.includes('administrativo')) {
          this.adm = true;
        }
      }
    },
    sair(){
      this.keycloak.logout({
      redirectUri: window.location.origin
    });
    },
    entrar(){
      this.keycloak.login();
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleSticky);
    this.isAuthenticated();
  },
};
</script>
